<script setup>
import mailchimpForm from '@/components/newsletter/MailchimpForm.vue';

const props = defineProps({
    data: { type: Object, default: () => {} },
});

const mailchimpSuccess = (props.data?.data?.mailchimpSuccess || '').trim() == '' ? undefined : props.data.data.mailchimpSuccess;
const mailchimpError = (props.data?.data?.mailchimpError || '').trim() == '' ? undefined : props.data.data.mailchimpError;
const mailchimpAlreadySubscribed = (props.data?.data?.mailchimpAlreadySubscribed || '').trim() == '' ? undefined : props.data.data.mailchimpAlreadySubscribed;
</script>

<template>
    <div
        v-if="data && data.data && data.data.mailchimpApiKey && data.data.mailchimpListId"
        class="MailchimpForm"
    >
        <div class="Page__right is-s">
            <div class="MailchimpForm__wrapper">
                <mailchimpForm
                    :api-key="data.data.mailchimpApiKey"
                    :list-id="data.data.mailchimpListId"
                    :success-message="mailchimpSuccess"
                    :failure-message="mailchimpError"
                    :existing-member-message="mailchimpAlreadySubscribed"
                    :tags="data.data.mailchimpTags"
                    :overrides="data.data.children"
                />
            </div>
        </div>
    </div>
</template>
